import React from 'react';
import { Stack } from '@mui/material';
import Header from '../components/Header';
import HomeContainer from '../components/HomeContainer';
import MainContainer from '../components/MainContainer';

const HomePage = () => {

    return (
        <Stack alignItems="center" sx={{flex: 1, height: '100%'}}>
            <Header/>
            <MainContainer>
                <HomeContainer/>
            </MainContainer>
        </Stack>
    );
};

export default HomePage;
